import { render, staticRenderFns } from "./BreadcrumbHeader.vue?vue&type=template&id=4b024288&scoped=true&"
import script from "./BreadcrumbHeader.vue?vue&type=script&lang=ts&"
export * from "./BreadcrumbHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BreadcrumbHeader.vue?vue&type=style&index=0&id=4b024288&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b024288",
  null
  
)

export default component.exports